module.exports = __webpack_public_path__ + "img/dev.28508b2b.png";